/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const RaiseHandIcon = /*#__PURE__*/ createSvgIcon(
  'RaiseHandIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <path
            d="M4.73 19c-1.029-.014-1.904-.382-2.626-1.104-.722-.722-1.09-1.597-1.104-2.625 0-.15.047-.275.142-.373a.476.476 0 01.358-.148c.144 0 .264.052.358.156a.526.526 0 01.142.365c0 .764.266 1.41.8 1.937A2.643 2.643 0 004.73 18c.15 0 .274.047.372.142a.476.476 0 01.148.358c0 .144-.05.264-.147.358a.517.517 0 01-.374.142zM18.5 5.02a.486.486 0 01-.5-.5c0-.707-.243-1.305-.73-1.79-.485-.487-1.082-.73-1.79-.73a.486.486 0 01-.5-.5.486.486 0 01.5-.5c.972 0 1.802.344 2.489 1.031A3.392 3.392 0 0119 4.521a.485.485 0 01-.5.5zM8.583 19c-.305 0-.59-.063-.853-.188a1.984 1.984 0 01-.688-.541L1.42 11.485a.735.735 0 01-.172-.527.75.75 0 01.231-.5l.083-.083c.237-.236.525-.378.865-.427.34-.049.656.017.948.198L6 11.687V3.75c0-.212.071-.39.214-.534A.72.72 0 016.746 3c.21 0 .39.072.535.216a.72.72 0 01.219.534V13a.71.71 0 01-.375.66.69.69 0 01-.75-.014L4.021 12.25l4.187 5.063a.8.8 0 00.177.135.402.402 0 00.198.052H14c.412 0 .766-.147 1.06-.44.293-.294.44-.647.44-1.06V4.75c0-.213.072-.39.214-.534A.72.72 0 0116.246 4c.21 0 .39.072.535.216A.72.72 0 0117 4.75V16c0 .833-.292 1.542-.875 2.125A2.893 2.893 0 0114 19H8.583zm1.33-18c.21 0 .39.072.535.216a.72.72 0 01.219.534v7.5c0 .213-.072.39-.215.534a.72.72 0 01-.531.216.734.734 0 01-.536-.216.72.72 0 01-.218-.534v-7.5c0-.212.071-.39.214-.534A.72.72 0 019.912 1zm3.166 1c.211 0 .39.072.536.216a.72.72 0 01.218.534v6.5c0 .213-.071.39-.214.534a.72.72 0 01-.531.216.734.734 0 01-.536-.216.72.72 0 01-.219-.534v-6.5c0-.212.072-.39.215-.534A.72.72 0 0113.079 2z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
  false
);

export default RaiseHandIcon;
